import { ReactNode } from "react";

interface ButtonProps {
  children: ReactNode; // Contenido del botón
  size?: "sm" | "md"; // Tamaño
  variant?: "primary" | "outline" | "secondary"; // Variante
  startIcon?: ReactNode; // Icono antes del texto
  endIcon?: ReactNode; // Icono después del texto
  onClick?: () => void; // Click handler
  disabled?: boolean; // Estado deshabilitado
  className?: string; // Clases adicionales
  type?: "button" | "submit" | "reset"; // Tipo de botón
}

const Button: React.FC<ButtonProps> = ({
  children,
  size = "md",
  variant = "primary",
  startIcon,
  endIcon,
  onClick,
  className = "",
  disabled = false,
  type = "button",
}) => {

  // Clases según tamaño
  const sizeClasses: Record<"sm" | "md", string> = {
    sm: "px-4 py-3 text-sm",
    md: "px-5 py-3.5 text-sm",
  };

  // Clases según variante
  const variantClasses: Record<"primary" | "outline" | "secondary", string> = {
    primary:
      "bg-brand-500 text-white shadow-theme-xs hover:bg-brand-600 disabled:bg-brand-300",
    outline:
      "bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300",
    secondary:
      "bg-gray-200 text-gray-900 hover:bg-gray-300 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700",
  };

  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-lg transition ${sizeClasses[size]} ${variantClasses[variant]} ${className} ${
        disabled ? "cursor-not-allowed opacity-50" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
    >
      {startIcon && <span className="flex items-center">{startIcon}</span>}
      {children}
      {endIcon && <span className="flex items-center">{endIcon}</span>}
    </button>
  );
};

export default Button;
